import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Pagination, buildPaginationUrl } from 'src/app/utility/services/paging/paging';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PpoListService {

  private routePrefix = '/api/ppoRequest';
  constructor(private http: HttpClient) { }

  getDynamicList(pagination: Pagination): Observable<any> {
    return this.http.get(
      buildPaginationUrl(this.routePrefix, "/page", pagination)
    );
  }

  getPpoRequestDetails(id: number): Observable<any> {
    return this.http.get(this.routePrefix + '/getPpoRequest/' + id);
  }

  getPPOBalance(id: number): Observable<any> {
    return this.http.get(this.routePrefix + "/getPPOBalance/" + id);
  }

  getLastHospitalWithPendingBalance(id: number): Observable<any> {
    return this.http.get(this.routePrefix + "/getLastHospital/" + id);
  }

  edit(data) {
    return this.http.put(`${this.routePrefix}/edit`, data);
  }

  updateSubmissionAndStatusType(data) {
    return this.http.patch(`${this.routePrefix}/update-submission-and-status-type`, data);
  }

  generatePPOClaimForm(data){
    return this.http.post(this.routePrefix + '/generate-ppo-claim-form', data, { responseType: 'blob' })
    .pipe(map((result: any) => {
        return result;
      })
    );
  }

  generatePPOBalanceSummary(ppoRequestId: number){
    return this.http.post(this.routePrefix + '/generate-ppo-balance-summary', ppoRequestId, { responseType: 'blob' })
    .pipe(map((result: any) => {
        return result;
      })
    );
  }

  getRequireNigoDocuments(claimEntryId: number): Observable<any> {
    return this.http.get(`${this.routePrefix}/get-require-nigo-documents/${claimEntryId}`);
  }

  downloadExcelReport(reportParams): Observable<any>{
    return this.http.post(this.routePrefix + '/download-report', reportParams);
  }
}
